import { debounce } from '@debbie/common/dist/util/index.js';
import { prefetchCaseData } from '@debbie/cortex/dist/cases/index.js';
// Same delay as the views queue, so passing over a row doesn't fetch.
const PREFETCH_DELAY_MS = 150;
// Hover handlers that load a case before it's opened.
export const prefetchCaseOnHover = (caseId) => ({
    onMouseEnter: () => debounce(`prefetch-case-${caseId}`, () => prefetchCaseData(caseId), PREFETCH_DELAY_MS),
    onMouseLeave: () => debounce(`prefetch-case-${caseId}`, () => { }, 0),
});
//# sourceMappingURL=prefetch-case.js.map